<svg
  aria-labelledby="title description"
  class="w-full h-auto fill-inherit"
  width='100%'
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <title>LinkedIn logo</title>
  <path fill="currentColor" d="M7.16286 32H0.528571V10.6352H7.16286V32ZM3.84214 7.72089C1.72071 7.72089 0 5.9637 0 3.84223C1.51843e-08 2.82321 0.404796 1.84592 1.12534 1.12536C1.84588 0.404805 2.82314 0 3.84214 0C4.86114 0 5.83841 0.404805 6.55895 1.12536C7.27949 1.84592 7.68429 2.82321 7.68429 3.84223C7.68429 5.9637 5.96286 7.72089 3.84214 7.72089ZM31.9929 32H25.3729V21.5998C25.3729 19.1211 25.3229 15.9425 21.9236 15.9425C18.4743 15.9425 17.9457 18.6354 17.9457 21.4212V32H11.3186V10.6352H17.6814V13.5496H17.7743C18.66 11.871 20.8236 10.0995 24.0514 10.0995C30.7657 10.0995 32 14.521 32 20.264V32H31.9929Z" />
</svg>
